// Custom Carousel JavaScript
const carouselStates = {};

function initCarousel(cardId) {
  if (!carouselStates[cardId]) {
    carouselStates[cardId] = {
      currentSlide: 0,
      totalSlides: 0
    };
    
    const carousel = document.querySelector(`[data-card-id="${cardId}"]`);
    if (carousel) {
      carouselStates[cardId].totalSlides = parseInt(carousel.dataset.slides) || 0;
    }
  }
}

function updateCarousel(cardId) {
  const track = document.getElementById(`track-${cardId}`);
  const dots = document.getElementById(`dots-${cardId}`);
  
  if (!track || !carouselStates[cardId]) return;
  
  const { currentSlide } = carouselStates[cardId];
  const translateX = -currentSlide * 100;
  
  track.style.transform = `translateX(${translateX}%)`;
  
  // Update dots
  if (dots) {
    const dotElements = dots.querySelectorAll('.card-carousel__dot');
    dotElements.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentSlide);
    });
  }
}

function nextSlide(cardId) {
  initCarousel(cardId);
  const state = carouselStates[cardId];
  
  if (state.currentSlide < state.totalSlides - 1) {
    state.currentSlide++;
  } else {
    state.currentSlide = 0; // Loop back to first slide
  }
  
  updateCarousel(cardId);
}

function prevSlide(cardId) {
  initCarousel(cardId);
  const state = carouselStates[cardId];
  
  if (state.currentSlide > 0) {
    state.currentSlide--;
  } else {
    state.currentSlide = state.totalSlides - 1; // Loop to last slide
  }
  
  updateCarousel(cardId);
}

function goToSlide(cardId, slideIndex) {
  initCarousel(cardId);
  carouselStates[cardId].currentSlide = slideIndex;
  updateCarousel(cardId);
}


// Initialize carousels when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.card-carousel');
  carousels.forEach(carousel => {
    const cardId = carousel.dataset.cardId;
    if (cardId) {
      initCarousel(cardId);
    }
  });
});

// Add keyboard navigation
document.addEventListener('keydown', function(e) {
  if (e.target.closest('.card-carousel')) {
    const carousel = e.target.closest('.card-carousel');
    const cardId = carousel.dataset.cardId;
    
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      prevSlide(cardId);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      nextSlide(cardId);
    }
  }
});

// Touch/Swipe functionality for mobile
let touchStartX = 0;
let touchEndX = 0;
let currentCarouselId = null;

function handleTouchStart(e) {
  const carousel = e.target.closest('.card-carousel');
  if (carousel) {
    currentCarouselId = carousel.dataset.cardId;
    touchStartX = e.changedTouches[0].screenX;
  }
}

function handleTouchEnd(e) {
  if (!currentCarouselId) return;
  
  touchEndX = e.changedTouches[0].screenX;
  handleSwipe();
}

function handleSwipe() {
  if (!currentCarouselId) return;
  
  const swipeThreshold = 50; // Minimum distance for a swipe
  const swipeDistance = touchEndX - touchStartX;
  
  if (Math.abs(swipeDistance) > swipeThreshold) {
    if (swipeDistance > 0) {
      // Swipe right - go to previous slide
      prevSlide(currentCarouselId);
    } else {
      // Swipe left - go to next slide
      nextSlide(currentCarouselId);
    }
  }
  
  // Reset values
  currentCarouselId = null;
  touchStartX = 0;
  touchEndX = 0;
}

// Add touch event listeners
document.addEventListener('touchstart', handleTouchStart, { passive: true });
document.addEventListener('touchend', handleTouchEnd, { passive: true });
